// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.error-modal-header h2 {
    margin: 0;
    font-size: 1.25rem;
    color: #1a1a1a;
}

.error-modal-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #fee2e2;
    color: #dc2626;
    font-size: 1.25rem;
}

.error-modal-message {
    color: #4a4a4a;
    margin: 0 0 24px 0;
    line-height: 1.5;
}

.error-modal-actions {
    display: flex;
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/errorModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".error-modal-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.error-modal-header h2 {\r\n    margin: 0;\r\n    font-size: 1.25rem;\r\n    color: #1a1a1a;\r\n}\r\n\r\n.error-modal-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    background-color: #fee2e2;\r\n    color: #dc2626;\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.error-modal-message {\r\n    color: #4a4a4a;\r\n    margin: 0 0 24px 0;\r\n    line-height: 1.5;\r\n}\r\n\r\n.error-modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
